import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { MediaDevicesState, MediaDeviceInfoLite } from "./types";
import { updateMediaDevices } from "./thunks";
export const mediaDevices = createSlice({
  name: "mediaDevices",
  initialState: {
    videoInputs: [],
    audioInputs: [],
    audioOutputs: [],
  } as MediaDevicesState,
  reducers: {},
  extraReducers: {
    [updateMediaDevices.fulfilled.type]: (
      state,
      { payload }: PayloadAction<MediaDevicesState>
    ) => {
      if (!areSame(state.videoInputs, payload.videoInputs)) {
        state.videoInputs = payload.videoInputs;
      }
      if (!areSame(state.audioInputs, payload.audioInputs)) {
        state.audioInputs = payload.audioInputs;
      }
      if (!areSame(state.audioOutputs, payload.audioOutputs)) {
        state.audioOutputs = payload.audioOutputs;
      }

      function areSame(
        inputs: MediaDeviceInfoLite[],
        currentInputs: MediaDeviceInfoLite[]
      ) {
        const inputIds = inputs.map((i) => i.deviceId + ":" + i.label).sort();
        const currentIds = currentInputs.map((i) => i.deviceId + ":" + i.label).sort();
    
        return inputIds.join(",") === currentIds.join(",");
      }
      
    },
    [updateMediaDevices.rejected.type]: (_, { error }) => {
      console.error(error);
    },
  },
});

export default mediaDevices.reducer;
